import script from "./NumberTagsAddEditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberTagsAddEditDialog.vue?vue&type=script&setup=true&lang=js"

import "./NumberTagsAddEditDialog.vue?vue&type=style&index=0&id=38874e1a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38874e1a"]])

export default __exports__